import type { SearchContext } from '@shared/types/types';
import type { OnEx } from '@tilelist/domain/experiments/OnEx.ts';

/**
 *
 *
 */
const ASSORTMENTS_WITH_TOP_INFO = [
    'Haushaltsgeräte',
    'Unterhaltungselektronik',
    'Optik',
    'Kommunikation',
    'Reinigungsgeräte',
    'Klima',
    'Bürotechnik',
    'Fahrzeuge',
    'Gartengeräte',
    'Heizen',
    'Sportausrüstung',
    'Zahnpflege',
    'Elektroinstallation',
] as const;

/**
 *
 *
 */
const V3_ASSORTMENTS = ['Möbel'] as const;

const ASSORTMENTS_SET = new Set(ASSORTMENTS_WITH_TOP_INFO.map((item) => item.toLowerCase()));
const V3_SET = new Set(V3_ASSORTMENTS.map((item) => item.toLowerCase()));

function normalizeAssortment(searchContext: SearchContext | undefined): string | undefined {
    const assortment = searchContext?.assortment;
    return assortment ? assortment.toLowerCase() : undefined;
}

function isExperimentAssortment(normalized: string, onex?: OnEx): boolean {
    return !!onex?.isExperimentGroup('CLEAN_TILE_V3', 'E3918B') && V3_SET.has(normalized);
}

export function shouldShowMultipleSizes(searchContext?: SearchContext, onex?: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    return isExperimentAssortment(normalized, onex);
}

export function shouldShowTopInfos(searchContext?: SearchContext, onex?: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return true;

    return isExperimentAssortment(normalized, onex);
}

/**
 *
 */
export function isInCleanTileV3Segment(searchContext?: SearchContext, onex?: OnEx): boolean {
    const normalized = normalizeAssortment(searchContext);
    if (!normalized) return false;

    const isBaseAssortment = ASSORTMENTS_SET.has(normalized);
    if (isBaseAssortment) return false;

    return V3_SET.has(normalized) && (onex?.isExperimentActive('CLEAN_TILE_V3') || false);
}
